import { Shrine } from '@a4b/api/src/modules/Temple/types'

/**
 * Helper to extract media URL from upload component's file list
 */
export const getMediaUrl = (fileList: any[]): string => {
  if (!Array.isArray(fileList) || fileList.length === 0) return ''
  const file =
    fileList.find(x => x?.status === 'done') ?? fileList[fileList.length - 1]
  if (typeof file === 'string') return file
  return (
    file?.url ||
    file?.thumbUrl ||
    file?.response?.url ||
    file?.response?.data?.url ||
    file?.response?.Location ||
    file?.response?.data?.Location ||
    ''
  )
}

/**
 * Format form values to API payload for creating Tithi
 */
export const formatTithiCreatePayload = (
  values: any,
): Shrine.CreateTithiPayload => {
  const mediaUrl = getMediaUrl(values.media)
  return {
    name: values.name,
    description_en: values.description_en,
    description_hi: values.description_hi,
    tithi_type: values.tithi_type,
    display_name_hi: values.display_name_hi,
    display_name_en: values.display_name_en,
    media: {
      media_type: values.media_type,
      media_url: mediaUrl,
    },
  }
}

/**
 * Format form values to API payload for updating Tithi
 */
export const formatTithiUpdatePayload = (
  values: any,
  tithiId: string,
): Shrine.UpdateTithiPayload => {
  const mediaUrl = getMediaUrl(values.media)
  return {
    id: tithiId,
    name: values.name,
    description_en: values.description_en,
    description_hi: values.description_hi,
    tithi_type: values.tithi_type,
    display_name_hi: values.display_name_hi,
    display_name_en: values.display_name_en,
    media: {
      media_type: values.media_type,
      media_url: mediaUrl,
    },
  }
}

export const parseTithiToFormFields = (record: Shrine.Tithi): any => {
  return {
    name: record.name,
    description_en: record.description_en,
    description_hi: record.description_hi,
    tithi_type: record.tithi_type,
    display_name_hi: record.display_name_hi,
    display_name_en: record.display_name_en,
    media_type: record.media?.media_type || '',
    media: record.media?.media_url ? [record.media.media_url] : [],
  }
}
